/**
 * R5 — RNG de session : seed généré au boot, shuffle déterministe du
 * plan scripté pour que mandat 2 ne reproduise pas mandat 1.
 *
 * Sortis de useGame.ts pour clarifier la responsabilité du store
 * (orchestrateur) face à la mécanique RNG (déterministe par seed).
 */

/**
 * N2 — seed 32-bit aléatoire pour une nouvelle partie. Persisté
 * dans la save pour garantir le replay déterministe.
 */
export function generateSeed(): number {
  return Math.floor(Math.random() * 0xffffffff);
}

/**
 * N2 — Fisher-Yates seedé via xorshift32. Shuffle uniquement les
 * positions des décisions symboliques (préfixe non `T`) dans la
 * `scripted_question_sequence`. Les T_ scriptés (T1_discours,
 * T6_hospitaux, etc.) restent à leur place.
 */
export function shuffleScriptedSymbolics(
  planJson: string,
  seed: number,
): string {
  const plan = JSON.parse(planJson);
  const seq: string[] = plan.scripted_question_sequence ?? [];
  if (seq.length === 0) return planJson;

  const symbolicIdx: number[] = [];
  for (let i = 0; i < seq.length; i++) {
    if (!seq[i].startsWith("T")) symbolicIdx.push(i);
  }
  if (symbolicIdx.length < 2) return planJson;

  let state = seed | 0 || 1;
  const next = () => {
    state ^= state << 13;
    state ^= state >>> 17;
    state ^= state << 5;
    return (state >>> 0) / 0x100000000;
  };

  const symbolicIds = symbolicIdx.map((i) => seq[i]);
  for (let i = symbolicIds.length - 1; i > 0; i--) {
    const j = Math.floor(next() * (i + 1));
    [symbolicIds[i], symbolicIds[j]] = [symbolicIds[j], symbolicIds[i]];
  }
  symbolicIdx.forEach((idx, k) => {
    seq[idx] = symbolicIds[k];
  });
  plan.scripted_question_sequence = seq;
  return JSON.stringify(plan);
}
